import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      teacherOptions: [
        { value: 1, label: '未联系文案老师' },
        { value: 2, label: '已联系文案老师' }
      ],
      booleanOptions: [
        { value: 1, label: '否' },
        { value: 2, label: '是' }
      ],
      submitOrgOptions: [
        { value: 1, label: '未提交' },
        { value: 2, label: '已提交' }
      ],
      materialFinish: [
        { value: 1, label: '初级' },
        { value: 2, label: '中级' },
        { value: 3, label: '高级' },
      ],
      handleState: [
        { value: 1, label: '申请中' },
        { value: 2, label: '延期中' },
        { value: 3, label: '已退办' },
        { value: 4, label: '未开始' },
        { value: 5, label: '已入学' }
      ],
      deliverState: [
        { value: 1, label: '未交付' },
        { value: 2, label: '已交付' }
      ],
      delayState: [
        { value: 1, label: '无延期史' },
        { value: 2, label: '有延期史' }
      ],
      JpSchoolType: [
        { value: 238, label: '语言学校申请' },
        { value: 4, label: '日本大学申请' }
      ],
      insideFinal: [
        { value: 1, label: '未通过' },
        { value: 2, label: '已通过' }
      ]
    };
  },
  methods: {
    /**
     * 是否有办理中流程
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     * @return {Boolean}
     */
    inProcess(process) {
      if (!process || (typeof process.process_id !== 'undefined' && !process.process_id)) {
        return false;
      }
      return !(process.is_delay === 2 || process.is_abort === 2 || process.is_start_school === 2);
    },
    /**
     * 保存流程
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     * @return {Promise}
     */
    saveProcess(processData) {
      let data = { ...processData };
      if (data.sign_status === '3' && !data.sign_date) {
        this.$message.error('递签日期必须填写');
        return false;
      }
      delete data.create_time;
      delete data.update_time;
      return this.$http._post({
        url: `/index/jp_process/save/id/${data.id}`,
        data
      }).then(() => {
        this.$message.success('保存成功');
      });
    },
    /**
     * 批量保存，提交，终审
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     * @param  {Object} data [description]
     * @return {Promise}      [description]
     */
    savePatch(data) {
      return this.$http._post({
        url: '/index/jp_process/patchSave',
        data: {
          data,
          ids: this.patchIds
        }
      }).then(() => {
        this.$message.success('保存成功');
      });
    },
    /**
     * 获取文案老师
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     * @return {Promise} [description]
     */
    getWriteTeachers() {
      return this.$http._get({
        url: 'index/api_base/writeTeacher'
      });
    }
  },
  computed: {
    /**
     * 是否为前程日本语言学校流程
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     * @return {Boolean}
     */
    isQcrb() {
      return this.$route.name.indexOf('qcrb_') > -1;
    },
    ...mapGetters(['userInfo']),
  }
};
